import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Font,
} from "@react-pdf/renderer";

import tajawalFont from "../../assets/font/Tajawal-Regular.ttf";

Font.register({
  family: "Tajawal",
  fonts: [
    {
      src: tajawalFont,
    },
  ],
});

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#ffffff",
    padding: 20,
    fontSize: 10,
    fontFamily: "Tajawal",
  },
  pageArabic: {
    flexDirection: "column",
    backgroundColor: "#ffffff",
    padding: 20,
    fontSize: 10,
    fontFamily: "Tajawal",
  },
  arabicText: {
    fontFamily: "Tajawal",
    textAlign: "right",
    direction: "rtl",
  },
  englishText: {
    fontFamily: "Tajawal",
    textAlign: "left",
    direction: "ltr",
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: 20,
    borderBottomWidth: 2,
    borderBottomColor: "#333333",
    paddingBottom: 15,
  },
  headerRTL: {
    display: "flex",
    flexDirection: "row-reverse",
    justifyContent: "space-between",
    alignItems: "flex-end",
    marginBottom: 20,
    borderBottomWidth: 2,
    borderBottomColor: "#333333",
    paddingBottom: 15,
  },
  companyInfo: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
  },
  companyName: {
    fontSize: 20,
    fontWeight: "bold",
    color: "#79329a",
    marginBottom: 5,
  },
  companyDetails: {
    fontSize: 8,
    color: "#666666",
  },
  companyDetailsRTL: {
    fontSize: 8,
    color: "#666666",
    textAlign: "right",
    direction: "rtl",
  },
  payslipTitle: {
    fontSize: 24,
    fontWeight: "bold",
    color: "#79329a",
    letterSpacing: 2,
  },
  infoSection: {
    flexDirection: "row",
    marginBottom: 20,
    gap: 30,
  },
  infoSectionRTL: {
    flexDirection: "row-reverse",
    marginBottom: 20,
    gap: 30,
  },
  infoBox: {
    flex: 1,
  },
  sectionHeader: {
    backgroundColor: "#79329abd",
    color: "#ffffff",
    padding: 5,
    fontSize: 9,
    fontWeight: "bold",
    marginBottom: 8,
    textAlign: "center",
  },
  infoRow: {
    flexDirection: "row",
    marginBottom: 3,
    fontSize: 9,
  },
  infoRowRTL: {
    flexDirection: "row-reverse",
    marginBottom: 3,
    fontSize: 9,
  },
  infoLabel: {
    fontWeight: "bold",
    marginRight: 5,
  },
  infoLabelRTL: {
    fontWeight: "bold",
    marginLeft: 5,
    textAlign: "right",
  },
  payslipInfoGrid: {
    flexDirection: "column",
    gap: 2,
  },
  gridRow: {
    flexDirection: "row",
    gap: 2,
  },
  gridRowRTL: {
    flexDirection: "row-reverse",
    gap: 2,
  },
  gridHeader: {
    flex: 1,
    backgroundColor: "#79329a8d",
    padding: 4,
    textAlign: "center",
    fontWeight: "bold",
    fontSize: 9,
  },
  gridValue: {
    flex: 1,
    backgroundColor: "#f3f4f6",
    padding: 4,
    textAlign: "center",
    fontSize: 9,
  },
  earningsSection: {
    marginBottom: 15,
  },
  sectionTitle: {
    backgroundColor: "#d1d5db",
    color: "#000000",
    padding: 6,
    fontSize: 10,
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: 2,
  },
  table: {
    flexDirection: "column",
    borderWidth: 1,
    borderColor: "#d1d5db",
  },
  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#e5e7eb",
    borderBottomWidth: 1,
    borderBottomColor: "#9ca3af",
  },
  tableHeaderRTL: {
    flexDirection: "row-reverse",
    backgroundColor: "#e5e7eb",
    borderBottomWidth: 1,
    borderBottomColor: "#9ca3af",
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#d1d5db",
  },
  tableRowRTL: {
    flexDirection: "row-reverse",
    borderBottomWidth: 1,
    borderBottomColor: "#d1d5db",
  },
  tableCell: {
    flex: 2,
    padding: 4,
    fontSize: 9,
    borderRightWidth: 1,
    borderRightColor: "#d1d5db",
  },
  tableCellCenter: {
    flex: 1,
    padding: 4,
    fontSize: 9,
    textAlign: "center",
    borderRightWidth: 1,
    borderRightColor: "#d1d5db",
  },
  tableCellRight: {
    flex: 1,
    padding: 4,
    fontSize: 9,
    textAlign: "right",
  },
  attendanceInfo: {
    flexDirection: "row",
    justifyContent: "space-around",
    margin: "8 0",
    fontSize: 9,
  },
  attendanceInfoRTL: {
    flexDirection: "row-reverse",
    justifyContent: "space-around",
    margin: "8 0",
    fontSize: 9,
  },
  totalRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    backgroundColor: "#d1d5db",
    padding: 6,
    fontWeight: "bold",
    fontSize: 10,
  },
  totalRowRTL: {
    flexDirection: "row-reverse",
    justifyContent: "space-between",
    backgroundColor: "#d1d5db",
    padding: 6,
    fontWeight: "bold",
    fontSize: 10,
  },
  netPayRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    backgroundColor: "#1f2937",
    color: "#ffffff",
    padding: 10,
    fontWeight: "bold",
    fontSize: 12,
    marginBottom: 15,
  },
  netPayRowRTL: {
    flexDirection: "row-reverse",
    justifyContent: "space-between",
    backgroundColor: "#1f2937",
    color: "#ffffff",
    padding: 10,
    fontWeight: "bold",
    fontSize: 12,
    marginBottom: 15,
  },
  footer: {
    fontSize: 8,
    textAlign: "center",
    color: "#6b7280",
    borderTopWidth: 1,
    borderTopColor: "#d1d5db",
    paddingTop: 8,
  },
});

const PayslipPDFTemplate = ({
  language = "EN",
  companyData = {},
  employeeData = {},
  payslipData = {},
  salaryData = {},
  deductionsBreakddown = [],
  entitlementsBreakdown = [],
}) => {
  const isArabic = language === "AR";

  // Default translations
  const translations = {
    EN: {
      payslip: "PAYSLIP",
      employeeInformation: "EMPLOYEE INFORMATION",
      payslipInformation: "PAYSLIP INFORMATION",
      fullName: "Full Name",
      address: "Address",
      phone: "Phone",
      email: "Email",
      payDate: "Pay Date",
      payType: "Pay Type",
      payrollNumber: "Receipt Number",
      paymentMethod: "Payment Method",
      period: "Period",
      earnings: "EARNINGS",
      rate: "RATE",
      amount: "AMOUNT",
      basicSalary: "Basic Salary",
      overtime: "Overtime",
      bonus: "Bonus",
      allowances: "Allowances",
      presentDays: "Present Days",
      absentDays: "Absent Days",
      vacationDays: "Vacation Days",
      expenses: "Expenses",
      grossPay: "GROSS PAY",
      deductions: "DEDUCTIONS",
      tax: "Tax",
      insurance: "Insurance",
      totalDeductions: "TOTAL DEDUCTIONS",
      netPay: "NET PAY",
      alhabbarSlogan: "Company Alhabbar for Software Development",
      ehsiblySecondSlogan: "Ehsibly Software for Management and Accounting",
    },
    AR: {
      payslip: "كشف الراتب",
      employeeInformation: "معلومات الموظف",
      payslipInformation: "معلومات كشف الراتب",
      fullName: "الاسم الكامل",
      address: "العنوان",
      phone: "الهاتف",
      email: "البريد الإلكتروني",
      payDate: "تاريخ الدفع",
      payType: "نوع الدفع",
      payrollNumber: "رقم الوصل",
      paymentMethod: "طريقة الدفع",
      period: "الفترة",
      earnings: "الدخل",
      rate: "المعدل",
      amount: "المبلغ",
      basicSalary: "الراتب الأسمي",
      grossSalary: "الراتب الإجمالي",
      overtime: "العمل الإضافي",
      bonus: "المكافأة",
      allowances: "البدلات",
      presentDays: "أيام الحضور",
      absentDays: "أيام الغياب",
      vacationDays: "أيام الإجازة",
      expenses: "المصروفات",
      grossPay: "إجمالي الراتب",
      deductions: "الاستقطاعات",
      tax: "الضريبة",
      insurance: "التأمين",
      totalDeductions: "إجمالي الاستقطاعات",
      netPay: "صافي الراتب",
      alhabbarSlogan: "شركة الحبّار للتطوير البرمجي",
      ehsiblySecondSlogan: "برنامج إحسبلي للإدارة والمحاسبة",
    },
  };

  const t = translations[language] || translations.EN;

  // Default data
  const defaultCompanyData = {
    name: isArabic ? "اسم الشركة" : "Company Name",
    address: isArabic
      ? "١٢٣٤ شارع المحكمة، لندن W1T 1JY، المملكة المتحدة"
      : "1234 Court Road, London W1T 1JY, UK",
    phone: "+44 00 0000 0000",
    email: "name@provider.com",
    ...companyData,
  };

  const defaultEmployeeData = {
    ...employeeData,
  };

  const defaultPayslipData = {
    payDate: "6/10/2019",
    payType: isArabic ? "شهري" : "Monthly",
    payrollNumber: "1234567",
    paymentMethod: isArabic ? "تحويل مصرفي" : "Bank Transfer",
    period: isArabic ? "أكتوبر ٢٠١٩" : "October 2019",
    ...payslipData,
  };

  const defaultSalaryData = {
    basicSalary: 2500.0,
    overtime: 150.0,
    bonus: 300.0,
    allowances: 200.0,
    presentDays: 22,
    absentDays: 0,
    vacationDays: 8,
    expenses: 50.0,
    tax: 250.0,
    insurance: 100.0,
    ...salaryData,
  };

  // Calculations
  const grossPay =
    defaultSalaryData.basicSalary +
    defaultSalaryData.overtime +
    defaultSalaryData.bonus +
    defaultSalaryData.allowances +
    defaultSalaryData.expenses;

  const totalDeductions = defaultSalaryData.tax + defaultSalaryData.insurance;

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "IQD",
    }).format(amount);
  };

  // Helper component for text with proper styling
  const StyledText = ({ children, style = {} }) => {
    const baseStyle = isArabic ? styles.arabicText : styles.englishText;
    return <Text style={{ ...baseStyle, ...style }}>{children}</Text>;
  };

  const payTypes = {
    MONTHLY: isArabic ? "شهري" : "Monthly",
    YEARLY: isArabic ? "سنوي" : "Yearly",
    WEEKLY: isArabic ? "أسبوعي" : "Weekly",
    DAILY: isArabic ? "يومي" : "Daily",
    HOURLY: isArabic ? "ساعي" : "Hourly",
    CONTRACT: isArabic ? "عقد" : "Contract",
  };

  const paymentMethods = {
    CASH: isArabic ? "كاش" : "Cash",
    BANK_TRANSFER: isArabic ? "تحويل مصرفي" : "Bank Transfer",
    CREDIT_CARD: isArabic ? "بطاقة ائتمان" : "Credit Card",
    MOBILE_PAYMENT: isArabic ? "دفع موبايل" : "Mobile Payment",
  };

  return (
    <Document>
      <Page size="A4" style={isArabic ? styles.pageArabic : styles.page}>
        {/* Header */}
        <View style={isArabic ? styles.headerRTL : styles.header}>
          <View style={styles.companyInfo}>
            <StyledText style={styles.companyName}>
              {defaultCompanyData.name}
            </StyledText>
            <StyledText
              style={
                isArabic ? styles.companyDetailsRTL : styles.companyDetails
              }
            >
              {isArabic ? "العنوان: " : "Address: "}
              {defaultCompanyData.address}
            </StyledText>
            <StyledText style={styles.companyDetails}>
              {isArabic ? "هاتف: " : "Phone: "}
              {defaultCompanyData.phone}
            </StyledText>
            <StyledText style={styles.companyDetails}>
              {isArabic ? "بريد إلكتروني: " : "Email: "}
              {defaultCompanyData.email}
            </StyledText>
          </View>
          <StyledText style={styles.payslipTitle}>{t.payslip}</StyledText>
        </View>

        {/* Employee and Payslip Info */}
        <View style={isArabic ? styles.infoSectionRTL : styles.infoSection}>
          {/* Employee Information */}
          <View style={styles.infoBox}>
            <StyledText style={styles.sectionHeader}>
              {t.employeeInformation}
            </StyledText>

            <View style={isArabic ? styles.infoRowRTL : styles.infoRow}>
              <StyledText
                style={isArabic ? styles.infoLabelRTL : styles.infoLabel}
              >
                {t.fullName}:
              </StyledText>
              <StyledText>{defaultEmployeeData.fullName}</StyledText>
            </View>

            <View style={isArabic ? styles.infoRowRTL : styles.infoRow}>
              <StyledText
                style={isArabic ? styles.infoLabelRTL : styles.infoLabel}
              >
                {t.address}:
              </StyledText>
              <StyledText>{defaultEmployeeData.address}</StyledText>
            </View>

            <View style={isArabic ? styles.infoRowRTL : styles.infoRow}>
              <StyledText
                style={isArabic ? styles.infoLabelRTL : styles.infoLabel}
              >
                {t.phone}:
              </StyledText>
              <StyledText>{defaultEmployeeData.phone}</StyledText>
            </View>

            <View style={isArabic ? styles.infoRowRTL : styles.infoRow}>
              <StyledText
                style={isArabic ? styles.infoLabelRTL : styles.infoLabel}
              >
                {t.email}:
              </StyledText>
              <StyledText>{defaultEmployeeData.email}</StyledText>
            </View>
          </View>

          {/* Payslip Information */}
          <View style={styles.infoBox}>
            <StyledText style={styles.sectionHeader}>
              {t.payslipInformation}
            </StyledText>
            <View style={styles.payslipInfoGrid}>
              <View style={isArabic ? styles.gridRowRTL : styles.gridRow}>
                <StyledText style={styles.gridHeader}>{t.payDate}</StyledText>
                <StyledText style={styles.gridValue}>
                  {defaultPayslipData.payDate}
                </StyledText>
              </View>
              <View style={isArabic ? styles.gridRowRTL : styles.gridRow}>
                <StyledText style={styles.gridHeader}>{t.payType}</StyledText>
                <StyledText style={styles.gridValue}>
                  {payTypes[defaultPayslipData.payType]}
                </StyledText>
              </View>
              <View style={isArabic ? styles.gridRowRTL : styles.gridRow}>
                <StyledText style={styles.gridHeader}>
                  {t.payrollNumber}
                </StyledText>
                <StyledText style={styles.gridValue}>
                  {defaultPayslipData.payrollNumber}
                </StyledText>
              </View>
              <View style={isArabic ? styles.gridRowRTL : styles.gridRow}>
                <StyledText style={styles.gridHeader}>
                  {t.paymentMethod}
                </StyledText>
                <StyledText style={styles.gridValue}>
                  {paymentMethods[defaultPayslipData.paymentMethod]}
                </StyledText>
              </View>
            </View>
          </View>
        </View>

        {/* Earnings Section */}
        <View style={styles.earningsSection}>
          <StyledText style={styles.sectionTitle}>{t.earnings}</StyledText>

          <View style={styles.table}>
            <View style={isArabic ? styles.tableHeaderRTL : styles.tableHeader}>
              <StyledText style={styles.tableCell}>{t.earnings}</StyledText>
              <StyledText style={styles.tableCellCenter}>{t.rate}</StyledText>
              <StyledText style={styles.tableCellRight}>{t.amount}</StyledText>
            </View>
            <View style={isArabic ? styles.tableRowRTL : styles.tableRow}>
              <StyledText style={styles.tableCell}>{t.basicSalary}</StyledText>
              <StyledText style={styles.tableCellCenter}>
                {formatCurrency(defaultSalaryData.hourlyRate)}
              </StyledText>
              <StyledText style={styles.tableCellRight}>
                {formatCurrency(defaultSalaryData.basicSalary)}
              </StyledText>
            </View>
            {entitlementsBreakdown.map((entitlement) => (
              <View
                key={entitlement.id}
                style={isArabic ? styles.tableRowRTL : styles.tableRow}
              >
                <StyledText style={styles.tableCell}>
                  {entitlement.name}
                </StyledText>
                <StyledText style={styles.tableCellCenter}>-</StyledText>
                <StyledText style={styles.tableCellRight}>
                  {formatCurrency(entitlement.amount)}
                </StyledText>
              </View>
            ))}

            <View style={isArabic ? styles.tableRowRTL : styles.tableRow}>
              <StyledText style={styles.tableCell}>{t.grossSalary}</StyledText>
              <StyledText style={styles.tableCellCenter}>-</StyledText>
              <StyledText style={styles.tableCellRight}>
                {formatCurrency(defaultSalaryData.grossSalary)}
              </StyledText>
            </View>
          </View>

          {/* Attendance Info */}
          <View
            style={isArabic ? styles.attendanceInfoRTL : styles.attendanceInfo}
          >
            <StyledText>
              {t.presentDays}: {defaultSalaryData.presentDays}
            </StyledText>
            <StyledText>
              {t.absentDays}: {defaultSalaryData.absentDays}
            </StyledText>
            <StyledText>
              {t.vacationDays}: {defaultSalaryData.vacationDays}
            </StyledText>
          </View>

          {/* Gross Pay */}
          <View style={isArabic ? styles.totalRowRTL : styles.totalRow}>
            <StyledText>{t.grossPay}</StyledText>
            <StyledText>
              {formatCurrency(defaultSalaryData.grossSalary)}
            </StyledText>
          </View>
        </View>

        {/* Deductions Section */}
        <View style={styles.earningsSection}>
          <StyledText style={styles.sectionTitle}>{t.deductions}</StyledText>
          <View style={styles.table}>
            {deductionsBreakddown.map((deduction) => (
              <View
                key={deduction.id}
                style={isArabic ? styles.tableRowRTL : styles.tableRow}
              >
                <StyledText style={styles.tableCell}>
                  {deduction.name}
                </StyledText>
                <StyledText style={styles.tableCellRight}>
                  {formatCurrency(deduction.amount)}
                </StyledText>
              </View>
            ))}
          </View>
        </View>

        {/* Net Pay */}
        <View style={isArabic ? styles.netPayRowRTL : styles.netPayRow}>
          <StyledText>{t.netPay}</StyledText>
          <StyledText>{formatCurrency(salaryData.netPay)}</StyledText>
        </View>

        {/* Footer */}
        <View
          fixed
          style={{
            position: "absolute",
            bottom: 20,
            left: 20,
            right: 20,
            textAlign: "center",
            paddingTop: 10,
            borderTopWidth: 1,
            borderTopColor: "#d1d5db",
            flexDirection: isArabic ? "column-reverse" : "column",
            alignItems: "center",
          }}
        >
          <Text
            style={{
              fontSize: 8,
              fontFamily: "Tajawal",
            }}
          >
            {t.alhabbarSlogan}
          </Text>
          <Text
            style={{
              fontSize: 10,
              fontWeight: "bold",
              marginBottom: 4,
              fontFamily: "Tajawal",
            }}
          >
            {t.ehsiblySecondSlogan}
          </Text>
        </View>
      </Page>
    </Document>
  );
};

export default PayslipPDFTemplate;
